import uuidv4 from 'uuid/v4';
import {postJson} from './fetchJson';
import confirmation from './widgets/confirmation.actions';

const createServiceWorkerUpdatePrompter = (dispatch, registration) => () => {
	dispatch(
		confirmation.open({
			title: 'New version',
			message: 'A new version of B2Me is available, a refresh is required for it to be installed.',
			buttons: ['continue', 'later'],
			onContinue: () => {
				if (registration.waiting) {
					registration.waiting.postMessage('SKIP_WAITING');
				}
			},
			onLater: null
		})
	);
};

export const registerServiceWorker = (firebase, dispatch) => {
	navigator.serviceWorker.register('/sw.js').then(registration => {
		const messaging = firebase.messaging();

		messaging.useServiceWorker(registration);

		const updateRefreshToken = getTokenRefresher(messaging);
		messaging.onTokenRefresh(updateRefreshToken);
		updateRefreshToken();

		const showServiceWorkerUpdatePrompt = createServiceWorkerUpdatePrompter(dispatch, registration);

		if (registration.waiting) {
			showServiceWorkerUpdatePrompt();
		}

		// Service worker update available
		// Kudos; https://whatwebcando.today/articles/handling-service-worker-updates/
		registration.addEventListener('updatefound', () => {
			if (registration.installing) {
				registration.installing.addEventListener('statechange', () => {
					if (registration.waiting) {
						if (navigator.serviceWorker.controller) {
							showServiceWorkerUpdatePrompt();
						}
					}
				});
			}
		});

		let refreshing = false;

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (!refreshing) {
				window.location.reload();
				refreshing = true;
			}
		});
	});
};

const getTokenRefresher = messaging => () =>
	messaging
		.getToken()
		.then(token => {
			postJson(`/api/user/token/`, {
				token,
				platform: 'Web',
				uuid: uuidv4()
			});
		})
		.catch(err => {
			if (
				err.message !==
				'Messaging: The notification permission was not granted and blocked instead. (messaging/permission-blocked).'
			) {
				console.error(err);
				postJson(`/api/error`, {
					message: err.message,
					source: err.source,
					lineno: err.lineno,
					colno: err.colno,
					userAgent: window.navigator && window.navigator.userAgent,
					platform: window.navigator && window.navigator.platform,
					stack: err.stack,
					href: window.location && window.location.href
				});
			}
		});



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js